import { Block } from '../components/Block'
import { Params, ParamValue } from '../components/Params'
import { Generator, ICreate, IGenerator } from './Generator'
import { PositionRef } from '../types';
import { updateParamWidth, updateParamHeight } from '../editors/update';
import { IDataLayout } from '../components/blockTypes';

export function dashboardGenerator(name: string, exParams?: Params) {

  const _topLeftWidth = '33%'
  const _topRightWidth = '33%'
  const _middleLefWidth = '20%'
  const _middleRightWidth = '20%'
  const _bottomLeftWidth = '33%'
  const _bottomRightWidth = '33%'

  const _topHeight = '20%'
  const _bottomHeight = '30%'


  const values: Array<[string, ParamValue]> = [
    ['topLeftWidth', _topLeftWidth],
    ['topRightWidth', _topRightWidth],
    ['middleLeftWidth', _middleLefWidth],
    ['middleRightWidth', _middleRightWidth],
    ['bottomLeftWidth', _bottomLeftWidth],
    ['bottomRightWidth', _bottomRightWidth],
    ['topHeight', _topHeight],
    ['bottomHeight', _bottomHeight],
  ]

  const _params = exParams
      ? exParams.restore(name, values)
      : new Params({
          name: 'desktopGenerator',
          initialValues: values
        })

  function init(g: IGenerator) {
    const params = g.params()
    const blocks = g.blocks()
    
    const topLeftWidth = params.get('topLeftWidth') as string
    const topRightWidth = params.get('topRightWidth') as string
    const topCenterWidth = `${100 - parseFloat(topLeftWidth) - parseFloat(topRightWidth)}%`

    const middleLeftWidth = params.get('middleLeftWidth') as string
    const middleRightWidth = params.get('middleRightWidth') as string
    const middleCenterWidth = `${100 - parseFloat(middleLeftWidth) - parseFloat(middleRightWidth)}%`

    const bottomLeftWidth = params.get('bottomLeftWidth') as string
    const bottomRightWidth = params.get('bottomRightWidth') as string
    const bottomCenterWidth = `${100 - parseFloat(bottomLeftWidth) - parseFloat(bottomRightWidth)}%`


    const topHeight = params.get('topHeight') as string
    const bottomHeight = params.get('bottomHeight') as string
    const middleHeight = `${100 - parseFloat(topHeight) - parseFloat(bottomHeight)}%`

    let p: IDataLayout

    // Define parts
    topLeft()
    topCenter()
    topRight()
    middleLeft()
    middleCenter()
    middleRight()
    bottomLeft()
    bottomCenter()
    bottomRight()

    return blocks
   
    function topLeft() {  
      p = {
        location: {
          left: 0,
          top: 0,
          width: topLeftWidth,
          height: topHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.right,
              variable: 'topLeftWidth',
              updateParam: updateParamWidth
            },
            {
              ref: PositionRef.bottom,
              variable: 'topHeight',
              updateParam: updateParamHeight
            }
          ]
        },
      }
      blocks.set('topLeft', p, g)
    }

    function topCenter() {
      p = {
        location: {
          left: topLeftWidth,
          top: 0,
          width: topCenterWidth,
          height: topHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.bottom,
              variable: 'topHeight',
              updateParam: updateParamHeight
            }
          ]
        },
      }
      blocks.set('topCenter', p, g)
    }

    function topRight() {  
      p = {
        location: {
          left: `${100 - parseFloat(topRightWidth)}%`,
          top: 0,
          width: topRightWidth,
          height: topHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.left,
              variable: 'topRightWidth',
              updateParam: updateParamWidth
            },
            {
              ref: PositionRef.bottom,
              variable: 'topHeight',
              updateParam: updateParamHeight
            }
          ]
        },
      }
      blocks.set('topRight', p, g)
    }

    function middleLeft() {  
      p = {
        location: {
          left: 0,
          top: topHeight,
          width: middleLeftWidth,
          height: middleHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.right,
              variable: 'middleLeftWidth',
              updateParam: updateParamWidth
            },
          ]
        },
      }
      blocks.set('middleLeft', p, g)
    }

    function middleCenter() {
      p = {
        location: {
          left: middleLeftWidth,
          top: topHeight,
          width: middleCenterWidth,
          height: middleHeight
        },
      }
      blocks.set('middleCenter', p, g)
    }

    function middleRight() {  
      p = {
        location: {
          right: 0,
          top: topHeight,
          width: middleRightWidth,
          height: middleHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.left,
              variable: 'middleRightWidth',
              updateParam: updateParamWidth
            },
          ]
        },
      }
      blocks.set('middleRight', p, g)
    }

    function bottomLeft() {  
      p = {
        location: {
          left: 0,
          bottom: 0,
          width: bottomLeftWidth,
          height: bottomHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.right,
              variable: 'bottomLeftWidth',
              updateParam: updateParamWidth
            },
            {
              ref: PositionRef.top,
              variable: 'bottomHeight',
              updateParam: updateParamHeight
            }
          ]
        },
      }
      blocks.set('bottomLeft', p, g)
    }

    function bottomCenter() {
      p = {
        location: {
          left: bottomLeftWidth,
          bottom: 0,
          width: bottomCenterWidth,
          height: bottomHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.top,
              variable: 'bottomHeight',
              updateParam: updateParamHeight
            }
          ]
        },
      }
      blocks.set('bottomCenter', p, g)
    }

    function bottomRight() {  
      p = {
        location: {
          left: `${100 - parseFloat(bottomRightWidth)}%`,
          bottom: 0,
          width: bottomRightWidth,
          height: bottomHeight
        },
        editor: {
          edits: [
            {
              ref: PositionRef.left,
              variable: 'bottomRightWidth',
              updateParam: updateParamWidth
            },
            {
              ref: PositionRef.top,
              variable: 'bottomHeight',
              updateParam: updateParamHeight
            }
          ]
        },
      }
      blocks.set('bottomRight', p, g)
    }
  }

  function create(args: ICreate): Block {
    return args.g.blocks().set(args.name, args.dataLayout, args.g)
  }

  return new Generator(name, init, _params, create)
}
